import * as types from "types";
import MessageUser from "./MessageUser";
import MessageFile from "./MessageFile";
import MessageToolResult from "./MessageToolResult";
import MessageAssistantTools from "./MessageAssistantTools";

interface MessageProps {
  chatThread?: types.ChatThread;
  message: types.Message;
  /**
   * Forwarded down to Markdown so MermaidDiagram / VegaLiteChart can defer
   * rendering during streaming.
   */
  isStreaming?: boolean;
  /**
   * Forwarded down to VegaLiteChart for `file://` data URLs.
   */
  getAccessToken?: () => Promise<string>;
  onAskAboutTask?: (prompt: string) => void;
  incognito?: boolean;
}

/** Routes each message variant to its specialized renderer. */
export default function Message({
  chatThread,
  message,
  isStreaming,
  getAccessToken,
  onAskAboutTask,
  incognito,
}: MessageProps) {
  if (types.isUserMessage(message)) {
    return <MessageUser content={message.content} />;
  } else if (types.isAssistantToolsMessage(message)) {
    return (
      <MessageAssistantTools
        chatThread={chatThread}
        subMessages={message.subMessages}
        isStreaming={isStreaming}
        getAccessToken={getAccessToken}
        onAskAboutTask={onAskAboutTask}
        incognito={incognito}
      />
    );
  }
  // Orphan tool result (no corresponding tool call message).
  else if (types.isToolResultMessage(message)) {
    return (
      <MessageToolResult
        toolCallId={message.tool_call_id}
        toolName={message.tool_name}
        content={message.content}
      />
    );
  }
  // File message
  else if (types.isFileMessage(message) && chatThread !== undefined) {
    return <MessageFile chatThread={chatThread} message={message} />;
  } else {
    return <MessageUser content={message.content} />;
  }
}
